import type { Routes } from '@angular/router';

export const AI_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('#modules/ai-settings/views/ai-settings/ai-settings.component').then((m) => m.AiSettingsComponent),
    },
];
